<!--
@Time : 2020/12/1 8:47 上午
@Author : yekong
@File : bianlimx.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="blx">
      <div class="leftb">
        <div class="item">
          实现银行预<br>约开户
        </div>
        <div class="item">
          取消公章刻<br>备案
        </div>
        <div class="item">
          实现数据共<br>享如何实现
        </div>
        <div class="item">
          银行设置自<br>助开户机
        </div>
      </div>
      <div class="rightb1">
        <div class="rightb2">
          <div class="rightb2item">
            <span>是</span>
            <span>否</span>
          </div>
        </div>
        <div class="rightb">
          <div class="rightbitem">
            <div class="rightbitem1">
              <div class="ct">上海</div>
              <div class="ct">深圳</div>
              <div class="ct">北京</div>
            </div>
            <div class="rightbitem1">
              <div class="ct">北京</div>
            </div>
          </div>
          <div class="rightbitem">
            <div class="rightbitem1">
              <div class="ct">深圳</div>
              <div class="ct">北京</div>
            </div>
            <div class="rightbitem1">
              <div class="ct">上海</div>
              <div class="ct">北京</div>
            </div>
          </div>
          <div class="rightbitem">
            <div class="rightbitem1">
              <div class="ct">上海</div>
              <div class="ct">北京</div>
            </div>
            <div class="rightbitem1">
              <div class="ct">深圳</div>
              <div class="ct">北京</div>
            </div>
          </div>
          <div class="rightbitem">
            <div class="rightbitem1">
              <div class="ct">北京</div>
            </div>
            <div class="rightbitem1">
              <div class="ct">北京</div>
              <div class="ct">深圳</div>
              <div class="ct">上海</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bianlimx",
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.blx {
  .leftb {
    height: 574px;
    width: 176px;
    margin-top: 50px;

    .item {
      text-align: left;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #39F9FF;
      margin-right: 29px;
      height: 142px;
      line-height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
    }
  }

  .rightb {
    width: 577px;
    height: 574px;
    border-left: 1px solid rgba(240, 242, 250, 1);
    //border-bottom: 1px solid #F0F2FA;
    display: flex;
    justify-content: flex-end;
    align-items:flex-end;
    flex-wrap: nowrap;
    flex-direction: column;
  }
}

.blx {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;

  .rightbitem {
    border-bottom: 1px solid rgba(186, 189, 201, 1);
    height: 142px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    width: 100%;

    .rightbitem1 {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
    }

    .rightbitem1:nth-child(1) {
      height: 142px;
      border-right: 1px solid #6F768E;
    }

    .ct {
      width: 72px;
      height: 52px;
      background: #C7CAD3;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #141D47;
      margin-left: 7px;
      margin-right: 7px;
    }
  }
}

.rightb2item {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #9BADFF;
}
</style>
